import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PortfolioHeader from '../portfolio/PortFolioHeader';

const MemoizedPortfolioHeader = () => {
  // Select only what's needed for the portfolio header
  const {
    balance,
    bookedPl,
    blockedMargin,
    brokerage,
    priceChangeConfig,
    showAccountDetails,
  } = useSelector((state) => state.trade);
  
  // For active trades, we need the trade history and quotes
  const tradeHistory = useSelector((state) => state.trade.tradeHistory);
  const quotesData = useSelector((state) => state.trade.quotesData);
  
  // Calculate active trades with latest price data
  const activeTrades = useMemo(() => {
    return tradeHistory
      .filter((trade) => trade.type === 'OPEN')
      .map((trade) => ({
        ...trade,
        script: { ...trade.script, ...quotesData[trade?.script?.instrument_token] },
      }));
  }, [tradeHistory, quotesData]);
  
  return (
    <PortfolioHeader
      balance={balance}
      bookedPL={bookedPl}
      blockedMargin={blockedMargin}
      brokerage={brokerage}
      activeTrades={activeTrades}
      priceChangeConfig={priceChangeConfig}
      showAccountDetails={showAccountDetails}
    />
  );
};

export default React.memo(MemoizedPortfolioHeader);
